module.exports = __webpack_public_path__ + "static/img/saimenInstallForWin_pic1.1f71d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/saimenInstallForWin/saimenInstallForWin_pic1.png
// module id = 576
// module chunks = 1